module.exports = __webpack_public_path__ + "files/4137d45bc7de2d4502614c9b5c6094b7.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-152x152.png
// module id = 1249
// module chunks = 76